import { Component } from 'san';
import * as _ from 'lodash';

import {
    IProject,
    IUpdateProjectInfo,
    IDiffProjectsParamsCallback,
    IShowDiffProjectsParams
} from 'src/models';
import diffProjectsService from 'src/services/diffProjects.service';

export default class DiffProjects extends Component {
    constructor(options: any) {
        super(options);
    }

    initData(): {
        isShow: boolean;
        callback: IDiffProjectsParamsCallback;    // 回调
        isShowUpdateProjects: boolean;
        isShowAddProjects: boolean;
        updateProjectInfos: IUpdateProjectInfo[];
        addProjects: IProject[];
    } {
        return {
            isShow: false,
            callback: undefined,
            isShowUpdateProjects: true,
            isShowAddProjects: true,
            updateProjectInfos: [],
            addProjects: []
        };
    }

    inited() {
    }

    //#region owner调用
    show(params: IShowDiffProjectsParams) {
        this.data.set('isShow', true);
        const callback = params.callback;
        this.data.set('callback', callback);
        this.data.set('secretProjectsPuids', params.secretProjectsPuids);
        if (callback) {
            callback(true);
        }
        this.getDiffProjects(params.auditId);
    }
    //#endregion

    getDiffProjects(auditId: string) {
        diffProjectsService.getDiffProjectsData(auditId).then(result => {
            // 为变更项目信息增加_is_secret属性，标识项目是否为保密项目
            const updateProjectInfos = result.updateProjectInfos;
            _.forEach(updateProjectInfos, project => {
                if(_.includes(this.data.get('secretProjectsPuids'), project.puid)) {
                    _.forEach(project.diffItems, item => {
                        item._is_secret = true;
                    })
                }
            });
            let dataKey = 'updateProjectInfos';
            const oldUpdateProjectInfos = this.data.get(dataKey);
            this.data.splice(dataKey, [0, oldUpdateProjectInfos.length, ...updateProjectInfos]);
            dataKey = 'addProjects';
            const oldAddProjects = this.data.get(dataKey);
            this.data.splice(dataKey, [0, oldAddProjects.length, ...result.addProjects]);
        });
    }

    toggleShowUpdateProjects() {
        const dataKey = 'isShowUpdateProjects';
        const value = this.data.get(dataKey);
        this.data.set(dataKey, !value);
    }

    toggleShowAddProjects() {
        const dataKey = 'isShowAddProjects';
        const value = this.data.get(dataKey);
        this.data.set(dataKey, !value);
    }

    close() {
        this.data.set('isShow', false);
        this.data.set('updateProjectInfos', []);
        this.data.set('addProjects', []);
        const callback = this.data.get('callback');
        if (callback) {
            callback(false);
        }
    }
}